import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Icons } from "assets/icons";

const SingleSelect = ({
  value,
  handleSingleSelectChange,
  options,
  className = "",
  error = null,
  placeholder = "Select option",
  disabled = false,
  panelClassName = "",
  label = null,
  required = null,
  readOnlyInput = false,
  infoText = null,
}) => {
  const { info } = Icons || {};

  return (
    <div className="position-relative">
        {label && (
          <label>
            {label}
            {required && <span className="text-danger">*</span>}
            {infoText && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{infoText}</Tooltip>}
              >
                <img
                  src={info}
                  alt="info"
                  width={15}
                  height={15}
                  style={{ cursor: "pointer" }}
                  className="ms-1"
                />
              </OverlayTrigger>
            )}
          </label>
        )}
      <Dropdown
        value={value}
        readOnlyInput={readOnlyInput}
        onChange={handleSingleSelectChange}
        options={options}
        optionLabel="name"
        placeholder={placeholder}
        className={`single_dropdown w-100 ${className}`}
        disabled={disabled}
        panelClassName={panelClassName}
      />
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
};

export default SingleSelect;
